import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const ConnectionsDirectoryHomePage = lazy(
  () => import('./connections-directory-home-page'),
);

export const ConnectionsDirectoryPage = () => {
  return (
    <LazyRoute>
      <ConnectionsDirectoryHomePage />
    </LazyRoute>
  );
};
